const l = {
  name: "PlayFilled",
  dimensions: { width: 100, height: 100 },
  content: `<svg fill="none">
                <circle cx="50" cy="50" r="50" fill="currentColor" />
                <path d="M65.9495 51.9625L43.9807 64.3229C42.6475 65.0731 41 64.1096 41 62.5799V37.4727C41 35.9312 42.6704 34.9692 44.0037 35.7428L65.9725 48.4895C67.3111 49.2662 67.2982 51.2036 65.9495 51.9625Z" fill="white"/>
              </svg>`
};
export {
  l as PlayFilled
};
